module.exports = __webpack_public_path__ + "media/images/app/login/google-icon-cc68b2d2804b77edfdd6b1a9ed0df255.svg";